import { render } from "./loaderApp.vue?vue&type=template&id=029f5484"
import script from "./loaderApp.vue?vue&type=script&lang=js"
export * from "./loaderApp.vue?vue&type=script&lang=js"

import "./loaderApp.vue?vue&type=style&index=0&id=029f5484&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__